var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIconUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25,
    stroke: "#BBBBBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1084 24.1875C24.1084 21.8058 26.0392 19.875 28.4209 19.875C30.8026 19.875 32.7334 21.8058 32.7334 24.1875C32.7334 26.5692 30.8026 28.5 28.4209 28.5C26.0392 28.5 24.1084 26.5692 24.1084 24.1875ZM33.2141 29.5435C34.6837 28.2274 35.6084 26.3155 35.6084 24.1875C35.6084 20.218 32.3905 17 28.4209 17C24.4514 17 21.2334 20.218 21.2334 24.1875C21.2334 26.3155 22.1582 28.2274 23.6277 29.5435C20.084 31.1705 17.5097 34.5461 17.0095 38.5654C16.9115 39.3532 17.5645 40 18.3584 40C19.1523 40 19.7834 39.3516 19.9142 38.5685C20.596 34.4863 24.1451 31.375 28.4209 31.375C32.6967 31.375 36.2458 34.4863 36.9277 38.5685C37.0585 39.3516 37.6895 40 38.4834 40C39.2773 40 39.9303 39.3532 39.8323 38.5654C39.3321 34.5461 36.7578 31.1705 33.2141 29.5435Z",
    fill: "#BBBBBD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconUser);
export default __webpack_public_path__ + "static/media/ModalIconUser.204fcf64cfd3fbe8121d578b90dee737.svg";
export { ForwardRef as ReactComponent };